import React from "react";
import Awardicon from "../assets/images/award-icon.png";
import Skeleton from "@mui/material/Skeleton";

const Leaderslist = ({ leadsData, loading }) => {
  console.log('leadsData', leadsData);
  
  return (
    <>
      <div className="leads-box d-flex">
        {loading
          ? [...Array(3)].map((_, index) => (
              <div className="leads-single" key={index}>
                <Skeleton
                  variant="rectangular"
                  width="100%"
                  height={500}
                  animation="wave"
                  sx={{
                    backgroundColor: "rgba(0, 0, 0, 0.05)",
                    borderRadius: 1,
                    marginBottom: 2,
                  }}
                />
              </div>
            ))
          : leadsData.map((singleLead, index) =>
              index === 0 ? (
                <div className="leads-single" key={index}>
                  <h2>קופות מקיפות מובילות</h2>
                  <div className="leads-single-box">
                    <div className="leads-title d-flex align-items-center">
                      <div className="leads-left">
                        <h3>{singleLead.subtitle}</h3>
                      </div>
                      <div className="icon">
                        <img src={Awardicon} alt="award icon" />
                      </div>
                    </div>
                    {singleLead?.leads?.filter((item) => item.classification == "קרנות חדשות")?.map((lead, leadIndex) => (
                      <div
                        className="leads-list d-flex align-items-center"
                        key={`first-${leadIndex}`}
                      >
                        <div className="leads-left d-flex align-items-center">
                          <div className="image">
                            {lead.image && (
                              <img
                                src={lead.image}
                                alt={`lead ${leadIndex + 1}`}
                              />
                            )}
                          </div>
                          <div className="description">{lead.description}</div>
                        </div>
                        <div className="leads-right">{lead.percentage}</div>
                      </div>
                    ))}
                  </div>
                  <h2 style={{ marginTop: "20px" }}>
                    קופות משלימות מובילות
                  </h2>
                  <div className="leads-single-box">
                    <div className="leads-title d-flex align-items-center">
                      <div className="leads-left">
                        <h3>{singleLead.subtitle}</h3>
                      </div>
                      <div className="icon">
                        <img src={Awardicon} alt="award icon" />
                      </div>
                    </div>
                    {singleLead.leads?.filter((item) => item.classification == "קרנות כלליות")?.map((lead, leadIndex) => (
                      <div
                        className="leads-list d-flex align-items-center"
                        key={`second-${leadIndex}`}
                      >
                        <div className="leads-left d-flex align-items-center">
                          <div className="image">
                            {lead.image && (
                              <img
                                src={lead.image}
                                alt={`lead ${leadIndex + 1}`}
                              />
                            )}
                          </div>
                          <div className="description">{lead.description}</div>
                        </div>
                        <div className="leads-right">{lead.percentage}</div>
                      </div>
                    ))}
                  </div>
                </div>
              ) : (
                <div className="leads-single" key={index}>
                  <h2>{singleLead.title}</h2>
                  <div className="leads-single-box">
                    <div className="leads-title d-flex align-items-center">
                      <div className="leads-left">
                        <h3>{singleLead.subtitle}</h3>
                      </div>
                      <div className="icon">
                        <img src={Awardicon} alt="award icon" />
                      </div>
                    </div>
                    {singleLead.leads.map((lead, leadIndex) => (
                      <div
                        className="leads-list d-flex align-items-center"
                        key={leadIndex}
                      >
                        <div className="leads-left d-flex align-items-center">
                          <div className="image">
                            {lead.image && (
                              <img
                                src={lead.image}
                                alt={`lead ${leadIndex + 1}`}
                              />
                            )}
                          </div>
                          <div className="description">{lead.description}</div>
                        </div>
                        <div className="leads-right">{lead.percentage}</div>
                      </div>
                    ))}
                  </div>
                </div>
              )
            )}
      </div>
    </>
  );
};

export default Leaderslist;
